import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IIndirectTaxFilingMissingServiceRequestItem,
  IIndirectTaxFilingsMissingServiceRequestParams,
} from './types';

interface IIndirectTaxFilingsMissingServiceRequestResponse {
  data: IIndirectTaxFilingMissingServiceRequestItem[];
  message: string;
}

/**
 * Filings that should have a service request but do not.
 *
 * Pass `null` params to hold the request — this scans across corporations, so it must be
 * triggered deliberately rather than on mount.
 */
export function useIndirectTaxFilingsMissingServiceRequests(
  params: IIndirectTaxFilingsMissingServiceRequestParams | null
) {
  const query = new URLSearchParams();

  if (params) {
    if (params.corporationId) {
      query.append('corporationId', params.corporationId.toString());
    }
    if (params.statuses?.length) {
      query.append('statuses', params.statuses.join(','));
    }
    if (params.dueDateFrom) {
      query.append('dueDateFrom', params.dueDateFrom);
    }
    if (params.limit) {
      query.append('limit', params.limit.toString());
    }
  }

  const key = params
    ? `new-sales-tax/internal/filings/service-requests/missing?${query.toString()}`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingsMissingServiceRequestResponse>(
      key,
      SWRFetcher({ method: 'GET' })
    );

  return {
    filings: data?.data ?? [],
    isLoading,
    error,
    mutate,
  };
}
